import { Skeleton, Box } from '@mui/material';

export const VideoCardSkeleton = () => (
  <Box>
    <Skeleton variant="rectangular" width="100%" height={300} />
    <Box sx={{ pt: 1 }}>
      <Skeleton width="80%" />
      <Skeleton width="60%" />
      <Skeleton width="40%" />
    </Box>
  </Box>
);